
const InventoryFilterResultItem = (props) => {
    return (
        <div className='inventory-filter-result-item'>
            <div className='inventory-filter-result-item-row'>
                <div className='inventory-filter-result-item-row-data flex-grow'>
                    <div>
                        <span className='inventory-filter-title-label'>
                            {props.Name}: 
                        </span>
                        <span className='inventory-filter-data-text'>
                            {props.Value}
                        </span>
                    </div>
                    <div>
                        <span className='inventory-filter-title-label'>
                            {props.DisplayKey}:
                        </span>
                        <span className='inventory-filter-data-text'>
                            {props.DisplayText}
                        </span>
                    </div>
                </div>
                <div className='inventory-filter-result-item-row-data flex-grow'>
                    {props.AdditionalFilteringByURL &&
                        <div className='view-all-container'>
                            <a href={props.AdditionalFilteringByURL} className='view-all-button'>
                                Apply Additional Filter
                            </a>
                        </div>}
                    <div className='view-all-container'>
                        {props.InventoryURL &&
                            <a href={props.InventoryURL} className='view-all-button' target='_Inventory'>
                                View {props.InventoryType}
                            </a>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InventoryFilterResultItem;